/*
 * action 类型
 */

export const type = {
  SWITCH_MENU: 'SWITCH_MENU',
  LOADER_ORDER: 'LOADER_ORDER',
  STATION_MODEL: 'STATION_MODEL',
  ORDER_FILTER: 'ORDER_FILTER',
  COMMON: 'COMMON',
}

//  
export function commonAction (data) {
  return dispatch => {
    dispatch({
      type: type.COMMON,
      appShow: data.appShow
    }) 
  }
}

// 菜单点击切换，修改面包屑名称
export function switchMenu (data) {
  return {
    type: type.SWITCH_MENU,
    ...data
  }
}

// 站场弹窗显示数据
export function stationModelShow (data) {
  return {
    type: type.LOADER_ORDER,
    ...data
  }
}